'use strict';

var subscription = {
    initOrderFlavourChangeEvent: function (product) {
        var product;
        $(document.body)
        .on('click', 'select.alternative-products', function () {
            product = $('option:selected', this).text();
        })
        .on('change', 'select.alternative-products', function () {
            var obj = {
                'event': 'subscriptionUpdateOrder',
                'event_step': 'Flavour Changed',
                'subscription_details': [product, $('option:selected', this).text()]
            }
            dataLayer.push(obj);
        });
    },
    initOrderQuantityChangeEvent: function () {
        var product,
        quantity,
        itemType;

        $(document.body)
        .on('focus', 'select.quantity', function () {
            quantity = $(this).val();
            var itemContainer = $(this).parents('.item-body');
            if (!itemContainer.data('subscription')) {
                product = itemContainer.find('div.item-name > div.item-name').text();
                itemType = 'One-time item';
            } else {
                var productsContainer = itemContainer.find('.alternative-products');
                product = $('option:selected', $(productsContainer)).text();
                itemType = 'Subscription';
            }
        })
        .on('change', 'select.quantity', function () {
            var obj = {
                'event': 'subscriptionUpdateOrder',
                'event_step': 'Quantity Changed'
            };
            if (quantity < $(this).val()) {
                quantity = $(this).val();
                obj['subscription_details'] = [product, 'Increase', itemType]
                obj['subscription_quantity'] = quantity;
                dataLayer.push(obj);
            } else if (quantity > $(this).val()) {
                quantity = $(this).val();
                obj['subscription_details'] = [product, 'Decrease', itemType]
                obj['subscription_quantity'] = quantity;
                dataLayer.push(obj);
            }
        });
    },
    initOrderFrequencyChangeEvent: function () {
        var product;
        $(document.body).on('click', 'select.frequency', function () {
            var itemContainer = $(this).parents('.item-body');
            product = itemContainer.find('.alternative-products').text();
        }).on('change', 'select.frequency', function () {
            var obj = {
                'event': 'subscriptionUpdateOrder',
                'event_step': 'Frequency Changed',
                'subscription_details': [product, $('option:selected', this).text()]
            };
            dataLayer.push(obj);
        });
    },
    triggerItemRemoveEvent: function (itemName, itemType) {
        var obj = {
            'event': 'subscriptionUpdateOrder',
            'event_step': 'Item Removed',
            'subscription_details': [itemName, itemType]
        };
        dataLayer.push(obj);
    },
    initAddressClickEvent: function () {
        $(document.body).on('click', '.edit-address', function () {
            var obj = {
                'event': 'subscriptionUpdateAddress',
                'event_step': 'Click',
                'interaction_details': 'My Upcoming Orders'
            };
            setWithExpiry('addressChangePage', 'SMI page', 5)
            dataLayer.push(obj);
        });
    },
    triggerAddressChangeEvent: function () {
        var location = getWithExpiry('addressChangePage');
        var obj = {
            'event': 'subscriptionUpdateOrder',
            'event_step': 'Address Changed'
        };
        if (!location) {
            obj.subscription_details = ['Address Book'];
            dataLayer.push(obj);
        } else {
            obj.subscription_details = [location];
            dataLayer.push(obj);
        };
    },
    triggerRescheduleOrderClickEvent: function ($orderSection) {
        var existingOrderDate = getExistingOrderDate ($orderSection)
        var obj = {
            'event': 'subscriptionReschedule',
            'event_step': 'Click',
            'interaction_details': existingOrderDate
        };
        dataLayer.push(obj);
    },
    triggerRescheduleOrderSendNowEvent: function ($orderSection) {
        var existingOrderDate = getExistingOrderDate ($orderSection)
        var newDate = getNewDate(new Date());
        var products = [];

        if ($orderSection.find('subscription-item-section')) {
            $orderSection.find('span.item-name').each(function () {
                products.push($(this).text());
            });
        };
        if ($orderSection.find('onetime-items-section')) {
            $orderSection.find('div.item-name > div.item-name').each(function () {
                products.push($(this).text());
            });
        };

        var obj = {
            'event': 'subscriptionReschedule',
            'event_step': 'Send Now',
            'subscription_details': [products, existingOrderDate, newDate]
        };
        dataLayer.push(obj);
    },
    triggerRescheduleOrderSkipOrderEvent: function ($orderSection, frequency, $button) {
        
        if (!frequency) {
            return;
        };
        var existingOrderDate = getExistingOrderDate ($orderSection)
        
        var newOrderDate = $button.parents('.reschedule-skip-order').find('.item-date').text().split('(')[0];
        var products = [];

        if ($orderSection.find('subscription-item-section')) {
            $orderSection.find('span.item-name').each(function () {
                products.push($(this).text());
            });
        };
        if ($orderSection.find('onetime-items-section')) {
            $orderSection.find('div.item-name > div.item-name').each(function () {
                products.push($(this).text());
            });
        };
        var obj = {
            'event': 'subscriptionReschedule',
            'event_step': 'Skip Order',
            'subscription_details': [products, existingOrderDate, newOrderDate]
        };
        dataLayer.push(obj);

    },
    triggerRescheduleOrderChangeDespatchDayEvent: function ($orderSection, frequency, $datepicker) {
        if (!frequency) {
            return;
        }
        var existingOrderDate = getExistingOrderDate ($orderSection)
        var newOrderDate = getNewDate($datepicker)
        var products = [];

        if ($orderSection.find('subscription-item-section')) {
            $orderSection.find('span.item-name').each(function () {
                products.push($(this).text());
            });
        }
        if ($orderSection.find('onetime-items-section')) {
            $orderSection.find('div.item-name > div.item-name').each(function () {
                products.push($(this).text());
            });
        }
        var obj = {
            'event': 'subscriptionReschedule',
            'event_step': 'Change Despatch Date',
            'subscription_details': [products, existingOrderDate, newOrderDate]
        };
        dataLayer.push(obj);

    },
    triggerCancelSubscriptionClickEvent: function (orderDetail) {
        var product = orderDetail.find('span.item-name').text();
        var obj = {
            'event': 'subscriptionCancel',
            'event_step': 'Click',
            'interaction_details': product
        };
        dataLayer.push(obj);

    },
    initCancelSubscriptionConfirmEvent: function () {
        var product;
        $(document.body).on('click', '.cancel-subscription', function () {
            var orderDetails = $(this).closest('div.subscription-item-section');
            product = orderDetails.find('span.item-name');
        });
        $(document.body).on('click', '.btn-cancel-reason', function () {
            var cancelReason = $('#cancel-reason option:selected').text();
            var obj = {
                'event': 'subscriptionCancel',
                'event_step': 'Confirm',
                'interaction_details': product.text() + "|" + cancelReason
            };
            dataLayer.push(obj);
        });
    },
    initBillingDetailsClickEvent: function () {
        $('div.billing-details').on('click', 'a.button', function () {
            var obj = {
                'event': 'subscriptionBilling',
                'event_step': 'Click',
                'interaction_details': 'My Billing Details | Button'
            }
            var expirationDate = $('span.expiration-date').text();
            var month = expirationDate.split('/')[0];
            var fullYear = expirationDate.split('/')[1];
            var date = new Date();
            date.setMonth(month);
            date.setFullYear(fullYear);
            expirationDate = date.toLocaleString('en-us', {month: 'long' , year: 'numeric'})
            setWithExpiry('cardInfo', expirationDate, 5);
            dataLayer.push(obj);
        })
    },
    initBillingDetailsCardChangeEvent: function () {
        $('button[value="Make Default"]').on('click', function () {
            var expirityDate = getWithExpiry('cardInfo');
            if (!expirityDate) {
                return;
            }
            var dateOfCardChange = getNewDate(new Date());
            var obj = {
                'event': "subscriptionUpdateOrder",
                'event_step': "Card Changed",
                'subscription_details': [expirityDate, dateOfCardChange]
            }
            dataLayer.push(obj);
        })
    },
    triggerReactivateSubscriptionClickEvent: function (status, failureReason) {
        if (!failureReason) {
            failureReason = '';
        }
        var product = $('.canceled-subscriptions').find('div.item-name').text();
        var obj = {
            'event': 'subscriptionReactivation',
            'event_step': 'Click',
            'interaction_details': product + "|" + status + "|" + failureReason
        };
        dataLayer.push(obj);
    },
    getSubscriptionAddToBagData: function () {
        if ($('.og-offer').length == 0 || $('input[name=subscriptionAddToBagEvents]').length == 0) {
            subscription.addSubscriptionAddToBagEvents();
            return;
        }

        var subscriptionAddToBagEvents = [];
        if ($('.primary-content input[name=subscriptionAddToBagEvents]').length) {
            subscriptionAddToBagEvents = JSON.parse($('.primary-content input[name=subscriptionAddToBagEvents]').val());
        }

        if (subscriptionAddToBagEvents.length == 0 && $('input[name=subscriptionAddToBagEvents]').length) {
            subscriptionAddToBagEvents = JSON.parse($('input[name=subscriptionAddToBagEvents]').val());
        }

        if (subscriptionAddToBagEvents.length) {
            subscription.addSubscriptionAddToBagEvents();
            return;
        }

        $.ajax({
            url: Urls.getAddToBagSubscriptionEvents,
            type: 'POST'
        }).done(function (response) {
            if (response.subscriptionAddToBagEvents) {
                $('input[name=subscriptionAddToBagEvents]').val(JSON.stringify(response.subscriptionAddToBagEvents));
                subscription.addSubscriptionAddToBagEvents();
            }
        });
    },

    addSubscriptionAddToBagEvents: function () {
        var subscriptionAddToBagEvents = [];
        var event = 'subscriptionsAddToBag';

        if ($('.pt_order-confirmation').length) {
            event = 'subscriptionsPurchase';
        }

        if ($('.primary-content input[name=subscriptionAddToBagEvents]').length) {
            subscriptionAddToBagEvents = JSON.parse($('.primary-content input[name=subscriptionAddToBagEvents]').val());
        }

        if (subscriptionAddToBagEvents.length == 0 && $('input[name=subscriptionAddToBagEvents]').length) {
            subscriptionAddToBagEvents = JSON.parse($('input[name=subscriptionAddToBagEvents]').val());
        }

        if (subscriptionAddToBagEvents.length == 0) {
            return;
        }

        for (var i = 0; i < subscriptionAddToBagEvents.length; i++) {
            var subscriptionData = subscriptionAddToBagEvents[i];
            subscriptionData.event = event;
            subscriptionData.clickType = getClickType();
            subscription.subscriptionAddToBagOrPurchasePushEvent(subscriptionData);
        }
    },
    subscriptionAddToBagOrPurchasePushEvent: function(subscriptionData) {
        dataLayer.push({
            event: subscriptionData.event,
            subscription_cat: subscriptionData.category,
            subscription_option: subscriptionData.option,
            subscription_frequency: subscriptionData.frequency,
            subscription_skus: subscriptionData.ID,
            click_type: subscriptionData.clickType
        });
    }
}

function getExistingOrderDate ($orderSection) {
    var date = new Date($orderSection.data('place'));
    return date.toLocaleString('en-us', {month: 'long' , year: 'numeric'});
}
function getNewDate (date) {
    return new Date(date).toLocaleString('en-us', {month: 'long' , year: 'numeric'});
}

function getWithExpiry(key) {
    const itemStr = localStorage.getItem(key);
    if (!itemStr) {
        return null;
    }
    const item = JSON.parse(itemStr)
    const now = new Date()
    if (now.getTime() > item.expiry) {
        localStorage.removeItem(key);
        return null;
    }
    return item.value;
}

function setWithExpiry(key, value, ttl) {
    var now = new Date()
    var min = ttl * 60 * 1000;
    var item = {
        value: value,
        expiry: now.getTime() + min
    }
    localStorage.setItem(key, JSON.stringify(item));
}

function getClickType () {
	var clickType = 'PDP - Standard';
	if ($('#QuickViewDialog').length) { 
		clickType = 'PDP - Quick View';
	}
	if ($('.pt_cart').length) {
		clickType = 'Checkout';
	}
	return clickType;
}

module.exports = subscription;